import { useEffect, useState } from 'react';
import api from '../api/client';

const STAT_FIELDS = [
  ['tasks', 'задача', 'задачи', 'задач'],
  ['solved', 'решение', 'решения', 'решений'],
  ['konspekts', 'конспект', 'конспекта', 'конспектов'],
  ['articles', 'статья', 'статьи', 'статей'],
  ['quizzes', 'тест', 'теста', 'тестов'],
  ['trainers', 'тренажёр', 'тренажёра', 'тренажёров'],
  ['students', 'ученик', 'ученика', 'учеников'],
  ['lessons', 'занятие', 'занятия', 'занятий'],
  ['lesson_hours', 'час', 'часа', 'часов'],
];

function ruPlural(n, one, few, many) {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return many;
  if (last > 1 && last < 5) return few;
  if (last === 1) return one;
  return many;
}

function formatCount(n) {
  return Number(n).toLocaleString('ru-RU');
}

export default function FooterStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/site-stats/')
      .then((res) => {
        if (!cancelled) setStats(res.data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!stats) return null;

  const items = STAT_FIELDS.flatMap(([key, one, few, many]) => {
    const value = Number(stats[key]);
    if (!Number.isFinite(value) || value <= 0) return [];
    return [{
      key,
      value: formatCount(value),
      label: ruPlural(value, one, few, many),
    }];
  });

  if (!items.length) return null;

  return (
    <ul className="footer-stats" aria-label="О платформе">
      {items.map((item) => (
        <li key={item.key}>
          <strong>{item.value}</strong>
          {' '}
          {item.label}
        </li>
      ))}
    </ul>
  );
}
